import $ from 'jquery';
import {Swiper, Autoplay, Pagination, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Autoplay, Pagination, Navigation]);


const gallerySwiper = new Swiper('.gallery-slider', {
	slidesPerView: 1,
	spaceBetween: 30,
	navigation: {
		prevEl: '.gallery-slider .swiper-button-prev',
		nextEl: '.gallery-slider .swiper-button-next',
	},
	loop: true,
	breakpoints: {
		1250: {
			slidesPerView: 3,
		},
		750: {
			slidesPerView: 2
		}

	}
});

export {gallerySwiper};
